import React from 'react';

function ApplicationRoutes(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-604.000000, -190.000000)">
          <g transform="translate(552.000000, 146.000000)">
            <g transform="translate(52.000000, 44.000000)" fill="#FFFFFF">
              <circle opacity="0.200000003" cx="12" cy="12" r="9" />
              <path d="M12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 Z M16,8 L6,13 L11,13 L11,18 L16,8 Z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ApplicationRoutes;
